import { api } from "./client";
import type { ReviewSummary, ReviewDetail, ReviewsListResponse } from "@/types";

export async function listReviews(params: {
  review_type?: string;
  days?: number;
  limit?: number;
  cursor?: string;
} = {}): Promise<ReviewsListResponse> {
  const query = new URLSearchParams();
  if (params.review_type) query.set("review_type", params.review_type);
  if (params.days) query.set("days", String(params.days));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.cursor) query.set("cursor", params.cursor);
  const suffix = query.toString() ? `?${query.toString()}` : "";
  const { data } = await api.get<ReviewsListResponse>(`/reviews${suffix}`);
  return data;
}

export async function getReview(id: number): Promise<ReviewDetail> {
  const { data } = await api.get<ReviewDetail>(`/reviews/${id}`);
  return data;
}

export async function getLatestWeekly(): Promise<{ review: ReviewDetail | null }> {
  const { data } = await api.get<{ review: ReviewDetail | null }>("/reviews/latest/weekly");
  return data;
}

export async function getLatestDaily(): Promise<{ review: ReviewDetail | null }> {
  const { data } = await api.get<{ review: ReviewDetail | null }>("/reviews/latest/daily");
  return data;
}
